export default __webpack_public_path__ + "static/media/037-drawkit-nature-man-colour-copy-2.e019bcf8.svg";